export const VALID_AMAZON_TLDS = [
  'ae',
  'ca',
  'cn',
  'co.jp',
  'co.uk',
  'com',
  'com.au',
  'com.be',
  'com.br',
  'com.mx',
  'com.tr',
  'de',
  'eg',
  'es',
  'fr',
  'in',
  'it',
  'nl',
  'pl',
  'sa',
  'se',
  'sg'
];

export const VALID_GOOGLE_TLDS = [
  'af',
  'al',
  'dz',
  'as',
  'ad',
  'ao',
  'ai',
  'ag',
  'ar',
  'am',
  'ac',
  'au',
  'at',
  'az',
  'bs',
  'bh',
  'bd',
  'by',
  'be',
  'bz',
  'bj',
  'bt',
  'bo',
  'ba',
  'bw',
  'br',
  'vg',
  'bn',
  'bg',
  'bf',
  'bi',
  'kh',
  'cm',
  'ca',
  'cv',
  'cat',
  'cf',
  'td',
  'cl',
  'cn',
  'co',
  'cd',
  'cg',
  'ck',
  'cr',
  'ci',
  'hr',
  'cu',
  'cy',
  'cz',
  'dk',
  'dj',
  'dm',
  'do',
  'ec',
  'eg',
  'sv',
  'ee',
  'et',
  'fj',
  'fi',
  'fr',
  'ga',
  'gm',
  'ge',
  'de',
  'gh',
  'gi',
  'gr',
  'gl',
  'gp',
  'gt',
  'gg',
  'gy',
  'ht',
  'hn',
  'hk',
  'hu',
  'is',
  'in',
  'id',
  'iq',
  'ie',
  'im',
  'il',
  'it',
  'ci',
  'jm',
  'jp',
  'je',
  'jo',
  'kz',
  'ke',
  'ki',
  'kw',
  'kg',
  'la',
  'lv',
  'lb',
  'ls',
  'ly',
  'li',
  'lt',
  'lu',
  'mk',
  'mg',
  'mw',
  'my',
  'mv',
  'ml',
  'mt',
  'mu',
  'mx',
  'fm',
  'md',
  'mn',
  'me',
  'ms',
  'ma',
  'mz',
  'na',
  'nr',
  'np',
  'nl',
  'nz',
  'ni',
  'ne',
  'ng',
  'nu',
  'nf',
  'no',
  'om',
  'pk',
  'ps',
  'pa',
  'pg',
  'py',
  'pe',
  'ph',
  'pn',
  'pl',
  'pt',
  'pr',
  'qa',
  'ro',
  'ru',
  'rw',
  'sh',
  'ws',
  'sm',
  'st',
  'sa',
  'sn',
  'rs',
  'sc',
  'sl',
  'sg',
  'sk',
  'si',
  'sb',
  'so',
  'za',
  'kr',
  'es',
  'lk',
  'vc',
  'sr',
  'se',
  'ch',
  'tw',
  'tj',
  'tz',
  'th',
  'tl',
  'tg',
  'tk',
  'to',
  'tt',
  'tn',
  'tr',
  'tm',
  'ug',
  'ua',
  'ae',
  'uk',
  'com',
  'uy',
  'uz',
  'vu',
  've',
  'vn',
  'vi',
  'zm',
  'zw'
];

export const VALID_WALMART_TLDS = [
  'com',
  'ca'
];

/*
 * The list is from a page that lists the domains where eBay's bug bounty program is applicable.
 */
export const VALID_EBAY_TLDS = [
  'com',
  'co.uk',
  'com.au',
  'de',
  'ca',
  'fr',
  'it',
  'es',
  'at',
  'ch',
  // 'com.hk', Information only, no products
  'com.sg',
  'com.my',
  // 'in', Information only, no products
  'ph',
  'ie',
  'pl',
  'be', // note: it has two subdomains: benl.ebay.be and befr.ebay.be
  'nl',
  // 'cn', // Information only, no products
  // 'com.tw', Information only, no products
  // 'co.jp' Information only, no products
];

export const VALID_REDFIN_TLDS = [
  'com',
  'ca'
];